import { Modal } from "@/components/elements/Modal";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TEmailSentModalProps = {
  isOpen: boolean;
  resent?: boolean;
  onClose: () => void;
};

// Confirmation modal shown after sending the verification mail.
// Copy switches to the "resent" variant once the user triggers a resend.
export const EmailSentModal: FC<TEmailSentModalProps> = ({ isOpen, resent = false, onClose }) => {
  const title = resent ? "認証メールを再送信しました" : "認証メールを送信しました";
  const body = resent ? "認証用URLが記載されたメールを再送信いたしました。" : "認証URLが記載されたメールを送信いたしました。";

  return (
    <Modal isOpen={isOpen} title={title} labelClose="閉じる" hiddenOkBtn onClose={onClose}>
      <Stack py="8px" mb="16px" width={360}>
        <Typography variant="body14" color={text.secondary}>
          {body}
        </Typography>
      </Stack>
    </Modal>
  );
};
